var exports = {
  "Y": "AltTextTooltip.module__tooltip___WHN3bD",
  "Q": "AltTextTooltip.module__text___WHN3bD",
};

module.exports = exports;
